import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AppService } from "../../services/app.service";

@Component({
  selector: "app-footer",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./footer.component.html",
  styleUrl: "./footer.component.scss",
})
export class FooterComponent implements OnInit {
  copyRight = "";

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.initCopyRight();
  }

  initCopyRight(): void {
    this.appService.getAppInfoValue("application.copyright").subscribe({
      next: (value) => {
        this.copyRight = value;
      },
      error: (err) => {
        console.error("Ошибка при получении данных", err);
      },
    });
  }
}
